import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { countryAdminRestrictedGuard } from '@shared/guard/country-admin-restricted.guard';
import { AdminModule } from '../admin/admin.module';
import { AuditHistoryModule } from '../audit-history/audit-history.module';
import { CountryInformationModule } from '../country-information/country-information.module';
import { DashboardModule } from '../dashboard/dashboard.module';
import { ManageEntitiesModule } from '../manage-entities/manage-entities.module';
import { PortfolioModule } from '../portfolio/portfolio.module';
import { TaxResultModule } from '../tax-result/tax-result.module';
import { HomeComponent } from './components/home/home.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => DashboardModule,
        canActivate: [countryAdminRestrictedGuard],
      },
      {
        path: 'admin',
        loadChildren: () => AdminModule,
      },
      {
        path: 'tax-results',
        loadChildren: () => TaxResultModule,
        canActivate: [countryAdminRestrictedGuard],
      },
      {
        path: 'portfolio',
        loadChildren: () => PortfolioModule,
        canActivate: [countryAdminRestrictedGuard],
      },
      {
        path: 'audit-history',
        loadChildren: () => AuditHistoryModule,
        canActivate: [countryAdminRestrictedGuard],
      },
      {
        path: 'entities',
        loadChildren: () => ManageEntitiesModule,
        canActivate: [countryAdminRestrictedGuard],
      },
      {
        path: 'country',
        loadChildren: () => CountryInformationModule,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
